import React, { useState } from 'react';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';

import {
  buttonBackground,
} from '../styles/colors';

export const MobileTable = styled.div`
  background-color: white;
  border: 1px solid white;

  @media (min-width: 1001px) {
    .mobileCollapse & {
      display: none;
    }
  }
`;

export const MobileTableHeader = styled.div`
  width: 100%;
`;

export const MobileTableCell = styled.div`
  flex: 1;
  min-width: 200px;

  .hideDetails & {
    display: none;
  }
`;

export const MobileTableActionCell = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  min-width: 200px;

  .hideDetails & {
    display: none;
  }
`;

export const MobileTableData = styled.div`
  font-size: 0.8rem;
  font-weight: 600;
  margin-top: 6px;
  margin-bottom: 12px;
`;

const MobileTableRowDiv = styled.div`
  border-bottom: 2px solid ${buttonBackground};
  padding: 16px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
`;

const ToggleDetails = styled.div`
  float: right;
`;

const ToggleIcon = styled(FontAwesomeIcon)`
  font-weight: 500;
  font-size: 1.2rem;
  color: ${buttonBackground};
  cursor: pointer;
`;

export const MobileTableRow = ({ children }) => {
  const [showDetails, setShowDetails] = useState(false);

  const toggleDetails = (
    <ToggleDetails>
      <ToggleIcon
        icon={faChevronDown}
        onClick={() => setShowDetails(!showDetails)}
      />
    </ToggleDetails>
  );

  return (
    <MobileTableRowDiv className={showDetails ? 'showDetails' : 'hideDetails'}>
      {children(toggleDetails)}
    </MobileTableRowDiv>
  );
}
